import $ from 'jquery';
import { Formatter } from '@dealersites/dealersite-js-core';

export function getTotalIMSIncentives(type) {
  let subTotal = $(`.js-non-targeted-incentives.${type}`).data('total');
  return  (subTotal ? subTotal: 0 ) + getTotalIMSTargetedSelected(type);
}

export function getTotalIMSTargetedSelected(type) {
  let total = 0
  $(`.js-targeted-incentive.${type}:checked`).each(function() {
    const targetedValue = $(this).parents('.js-targeted-incentive-label').find('.targeted-value');
    total+=targetedValue.data('value'); 
  });
  return total;
}

export function updateTotalPrice(price, elemTotal, type) {
  price = price - getTotalIMSIncentives(type);
  elemTotal.each(function () {
    $(this).text(Formatter.price(price, 2));
  });

}